import { useTranslation } from 'react-i18next'

import { validateJSON } from '@/common/utils/validateJSON'
import { z } from '@/lib/zod'

export function ApplicationAccountSchema() {
  const { t } = useTranslation('sso')

  return z.object({
    applicationId: z.string().nonempty(),
    tag: z
      .array(
        z.object({
          label: z.string(),
          value: z.string(),
        }),
      )
      .default([]),
    accountFields: z
      .string()
      .optional()
      .refine((value) => (value ? validateJSON(value) : true), {
        message: t(
          'accounts.drawer_manage_applications.schema.account_fields.invalid_json',
        ),
      }),
    isMainAccount: z.boolean().default(false),
  })
}

export type ApplicationAccountForm = z.infer<
  ReturnType<typeof ApplicationAccountSchema>
>
